import { Maybe, VisitVariantType } from '@csp/csp-common-model';
import { WebHcpPatientVisitEntry } from '@csp/csp-web-content-definitions';
import { ScheduleVersionRequestRef } from '@csp/csp-common-scheduling';
import { ScheduleVisitsContent } from '../model/ScheduleVisitsContent';
import { BookedVisit } from '../model/BookedVisit';
import { ScheduleVisitTexts } from '../model/ScheduleVisitTexts';
import { VisitRequest } from '../schedule/model/VisitRequest';

const fromVisitRequest = (
  patientVisitTexts: WebHcpPatientVisitEntry,
  visitsContent: ScheduleVisitsContent,
  visitRequest: VisitRequest,
  visit: Maybe<BookedVisit>,
): ScheduleVisitTexts =>
  visitRequest.variant === VisitVariantType.UNSCHEDULED
    ? {
        title: patientVisitTexts.visitDetails.textLabel.unscheduledVisit.label,
        visitKind: patientVisitTexts.visitType.enum.UNSCHEDULED,
        // Setting visit description to hcpDescription for unscheduled visits even if it is shared with the app.
        // This is because it should be mapped to visit purpose.
        hcpDescriptionMd: visit?.description,
      }
    : visitsContent.getScheduleVisitTexts(ScheduleVersionRequestRef.fromGenericRequest(visitRequest));

export const ScheduleVisitTextsMapper = {
  fromVisitRequest,
};
